import React from "react";
import { Text, TextProps } from "@ui-kitten/components";

const WhiteText: React.FC<TextProps> = ({ style, children, ...rest }) => (
  <Text style={[{ color: "white" }, style]} {...rest}>
    {children}
  </Text>
);

export default WhiteText;
